import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import SpecialtiesSection from './components/SpecialtiesSection';
import TreatmentsSimple from './components/TreatmentsSimple';
import CTASection from './components/CTASection';
import LocationSection from './components/LocationSection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <HeroSection />
      <AboutSection />
      <SpecialtiesSection />
      <TreatmentsSimple />
      <CTASection />
      <LocationSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
